import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchPublicIP = createAsyncThunk(
  'ip/fetchPublicIP',
  async () => {
    const res = await fetch('https://api.ipify.org/?format=json')
    const data = await res.json()
    return data.ip
  }
)

const ipSlice = createSlice({
  name: 'ip',
  initialState: {
    address: null,
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicIP.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchPublicIP.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.address = action.payload
      })
      .addCase(fetchPublicIP.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
        state.address = '0.0.0.0 (Failed)'
      })
  }
})

export default ipSlice.reducer
